export default function ImagePickerButtons({
  onSelect,
  className = '',
  cameraLabel = 'الكاميرا',
  galleryLabel = 'المعرض',
  multiple = false,
}) {
  const handlePick = (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length) {
      onSelect(multiple ? files : files[0]);
    }

    event.target.value = '';
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`.trim()}>
      <label className="inline-flex items-center justify-center rounded-lg border border-slate-300 px-3 py-2 cursor-pointer hover:bg-slate-50 text-sm font-medium text-slate-700">
        {cameraLabel}
        <input
          type="file"
          accept="image/*"
          capture="environment"
          multiple={multiple}
          className="hidden"
          onChange={handlePick}
        />
      </label>

      <label className="inline-flex items-center justify-center rounded-lg border border-slate-300 px-3 py-2 cursor-pointer hover:bg-slate-50 text-sm font-medium text-slate-700">
        {galleryLabel}
        <input
          type="file"
          accept="image/*"
          multiple={multiple}
          className="hidden"
          onChange={handlePick}
        />
      </label>
    </div>
  );
}
